import request from '@/utils/request'
import store from '@/store'

// 获取当前登录用户的 adminId
function getAdminId() {
  return store.state.userInfo?.id || store.state.userInfo?.adminId || JSON.parse(localStorage.getItem('userInfo') || '{}').id
}

// 登录
export function login(data) {
  return request({
    url: '/admin/login',
    method: 'post',
    data: {
      username: data.username,
      password: data.password
    }
  })
}

// 获取用户信息
export function getUserInfo() {
  return request({
    url: '/admin/info',
    method: 'get'
  })
}

// 修改密码
export function updatePassword(data) {
  return request({
    url: '/admin/password',
    method: 'put',
    data
  })
}

// 获取用户列表
export function getUserList(params) {
  return request({
    url: '/user/list',
    method: 'get',
    params: {
      ...params,
      adminId: getAdminId()
    }
  })
}

// 删除用户
export function deleteUser(id) {
  return request({
    url: `/user/delete/${id}`,
    method: 'delete',
    params: {
      adminId: getAdminId()
    }
  })
}

// 导出用户参与记录
export function exportUser(data) {
  return request({
    url: '/user/exportUser',
    method: 'get',
    params: {
      ...data,
      adminId: getAdminId()
    },
    responseType: 'blob' // 重要：设置响应类型为 blob
  })
}
